import React from "react";
import "./App.css";
import BluetoothConnect from "./BluetoothConnect";

function App() {
  return <BluetoothConnect />;
}

export default App;
